import React from 'react';
import { connect } from 'react-redux';
import { InfoBar } from 'ctia-ui';
import { lastWizardStep } from 'actions/wizard';
import { getDeviceTitle } from 'helpers/DeviceTypeHelper';
import { getBandsAsString } from 'helpers/Bands';

const InfoBarEco = ({ wizard, model }) => {
  if (!wizard || !model || !model.info || !model.versions) return null;

  const { modelnumber, devicetypeid, devicemodelbands, vendor } = model.info;

  const reqDataInfo = [
    {
      key: 'Manufacturer',
      value: vendor.name
    },
    {
      key: 'Model Name/Number',
      value: modelnumber
    },
    {
      key: 'Device Type',
      value: getDeviceTitle(devicetypeid)
    },
    {
      key: 'Bands',
      value: getBandsAsString(devicemodelbands)
    }
  ];

  const { step } = wizard;

  return (
    <InfoBar show={step > 1 && step < lastWizardStep} data={reqDataInfo} />
  );
};

function mapStateToProps({ wizard, model }) {
  return { wizard, model };
}

export default connect(mapStateToProps)(InfoBarEco);



// WEBPACK FOOTER //
// ./src/containers/request/ECO/InfoBar.js